import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { get, curry } from 'lodash';

const NAME = 'compositions_DealerLocator_withAfterHoursData';

const query = gql`
  query ${NAME} ($id: ID!) {
    dealer (id: $id) {
      id
      activeAfterHoursContacts {
        contacts {
          backupContact {
            id
            jobTitle
            name
            primaryPhoneNumber
            secondaryPhoneNumber
          }
          finalContact {
            id
            jobTitle
            name
            primaryPhoneNumber
            secondaryPhoneNumber
          }
          primaryContact {
            id
            jobTitle
            name
            primaryPhoneNumber
            secondaryPhoneNumber
          }
        }
      }

      afterHoursRotationContacts {
        start
        end
        contacts {
          backupContact {
            id
            jobTitle
            name
            primaryPhoneNumber
            secondaryPhoneNumber
          }
          finalContact {
            id
            jobTitle
            name
            primaryPhoneNumber
            secondaryPhoneNumber
          }
          primaryContact {
            id
            jobTitle
            name
            primaryPhoneNumber
            secondaryPhoneNumber
          }
        }
      }

      allContacts: ahContacts {
        id
        jobTitle
        name
        primaryPhoneNumber
        secondaryPhoneNumber
      }
    }
  }
`;

export const buildQueryChild = curry(
  (WrappedComponent, componentProps, queryProps) => {
    const { data, loading, refetch, error, networkStatus } = queryProps;

    const isLoading = !!loading || networkStatus === 4; // loading or refetching
    const allContacts = get(data, 'dealer.allContacts');
    const activeContacts = get(data, 'dealer.activeAfterHoursContacts');
    const afterHoursContacts = get(data, 'dealer.afterHoursRotationContacts');

    return (
      <WrappedComponent
        {...componentProps}
        allContacts={allContacts}
        reloadAfterHoursData={() => refetch()}
        isLoadingAfterHoursData={isLoading}
        activeAfterHoursContacts={activeContacts}
        afterHoursRotationContacts={afterHoursContacts}
        didFailLoadingAfterHoursData={!!error}
      />
    );
  },
);

export default WrappedComponent => cProps => {
  const id = get(cProps, 'dealer.id');

  return (
    <Query
      skip={!id}
      query={query}
      variables={{ id }}
      pollInterval={!id ? 0 : 30 * 1000}
    >
      {buildQueryChild(WrappedComponent, cProps)}
    </Query>
  );
};



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/SearchResultsList/DealerList/withAfterHoursData.js